
export function refineResources( resources ) {
    if ( !resources || resources.length == 0 ) { return []; }

    // Convert the list of raw curriculums into their "refined" forms.
    const refinedCurriculumList = resources.edges.map( ( res ) => {
        return {
            ...res?.node,
            lxp: {
                relatedResourceBrandIds: res.node.brandIds,
                relatedResourceLocaleIds: res.node.localeIds,
                relatedResourceCompanyRelationshipIds: res.node.companyRelationshipIds,
                relatedResourceProductIds: res.node.productIds,
                tags: res.node.tags,
            }
        };
    } );

    return refinedCurriculumList;
}
